import { createContext, FC } from "react";
import { useSelector } from "react-redux";
import ModalTypesEnum from "../../utils/mapper/enums/ModalTypesEnum";
import DocumentProcessingRequestModal from "./DocumentModals/DocumentProcessingRequestModal";
import CreateDeliveryFeeModal from "./admin/delivery/CreateDeliveryFeeModal";
import EditDeliveryFeeModal from "./admin/delivery/EditDeliveryFeeModal";
import FindChatStudentModal from "./chat/FindChatStudentModal";

export const MODAL_COMPONENTS = {
  [ModalTypesEnum.DOCUMENT_REQUEST]: DocumentProcessingRequestModal,
  [ModalTypesEnum.DELIVERY_FEE_REQUEST]: CreateDeliveryFeeModal,
  [ModalTypesEnum.DELIVERY_FEE_EDIT_REQUEST]: EditDeliveryFeeModal,
  [ModalTypesEnum.CHAT_USER_FETCH_REQUEST]: FindChatStudentModal,
};

export const modalContext = createContext({});

const ModalRootContainer = () => {
  const {
    modal: { modalType, modalData },
  } = useSelector(({ modalReducer }) => ({ modal: modalReducer }));
  if (!modalType) {
    return null;
  }

  const ActiveModal = MODAL_COMPONENTS[modalType];

  return (
    <modalContext.Provider value={modalData}>
      <ActiveModal />
    </modalContext.Provider>
  );
};

export default ModalRootContainer;
